import {useTranslation} from "react-i18next";
import logo from "../../../assets/images/coronando-logo.svg";
import {useBrandTitle} from "../../../util/logoUtils";

const supportModalContainerCls =
  "py-6 px-4 w-full box-border flex flex-col items-center gap-2 max-[600px]:p-2";
const logoWrapperCls = "flex justify-center items-center mb-2";
const supportLogoCls =
  "w-[110px] h-[90px] object-contain max-[600px]:w-[70px] max-[600px]:h-[56px]";
const supportTitleCls = "text-center mb-2 text-2xl font-bold text-[var(--color-primary)]";
const supportDescriptionCls = "text-center mb-4 text-base text-[var(--color-text-secondary)]";
const contactGridCls = "flex flex-col gap-2 w-full items-center";
const contactRowCls =
  "flex flex-row items-center justify-between w-full gap-4 text-[var(--color-text)] text-sm";
const contactLabelCls = "font-semibold text-left min-w-[90px]";
const contactValueCls = "text-right flex-1";
const whatsappButtonCls = "border-0 inline-block text-[var(--color-primary)] underline";

const Support = () => {
  const {t} = useTranslation();
  const brandTitle = useBrandTitle();

  return (
    <div className={supportModalContainerCls}>
      <div className={logoWrapperCls}>
        <img
          src={logo}
          alt={brandTitle}
          className={supportLogoCls}
        />
      </div>
      <h2 className={supportTitleCls}>{t("support_title_message")}</h2>
      <div className={supportDescriptionCls}>{t("support_message")}</div>
      <div className={contactGridCls}>
        <div className={contactRowCls}>
          <span className={contactLabelCls}>{t("support_modal_email")}:</span>
          <span className={contactValueCls}>
            <a
              href="mailto:soporte@coronando.com"
              className="underline !text-[var(--color-primary)]"
              style={{ color: 'var(--color-primary)' }}
            >
              soporte@coronando.com
            </a>
          </span>
        </div>
        <div className={contactRowCls}>
          <span className={contactLabelCls}>Telegram:</span>
          <span className={contactValueCls}>
            <a
              href="https://t.me/coronando_soporte"
              target="_blank"
              rel="noopener noreferrer"
              className="underline !text-[var(--color-primary)]"
              style={{ color: 'var(--color-primary)' }}
            >
              @coronando_soporte
            </a>
          </span>
        </div>
        <div className={contactRowCls}>
          <span className={contactLabelCls}>WhatsApp:</span>
          <span className={contactValueCls}>
            <a
              href="https://wa.me/+584120000000"
              target="_blank"
              rel="noopener noreferrer"
              className="underline !text-[var(--color-primary)]"
              style={{ color: 'var(--color-primary)' }}
            >
              +58 412 0000000
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Support;
